import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { status } from 'constants/general';
import advertsStrings from 'modules/adverts/strings';
import AdvertsFilter from 'modules/adverts/components/AdvertsFilter';
import AdvertsList from 'modules/adverts/components/AdvertsList';
import Loader from 'modules/common/components/Loader';
import Pagination from 'modules/common/components/Pagination';

import {
  AdvertsWrapper,
  LoaderWrapper,
  NoResultsWrapper,
  NoResultsText,
  PaginationWrapper,
  ToastTextOverlay,
} from './AdvertsComponent.style';

const AdvertsComponent = ({
  showCopiedTextOverlay,
  searchQuery,
  selectedPageFilter,
  isActionPopupOpen,
  isActionPopupLoading,
  actionPopupStatus,
  handleTextToCopyToClipboardClick,
  handleSearchBarInputChange,
  handleOrderPaginationClick,
  handleActionBtnClick,
  handleActionPopupConfirmBtnClick,
  handleActionPopupDismissBtnClick,
}) => {
  const { advertsList } = useSelector(state => ({
    advertsList: state.adverts.advertsList,
  }));

  const totalResultsCount = advertsList?.details?.totalCount;
  const numberOfPages = (totalResultsCount && Math.ceil(totalResultsCount / 10)) || 1;
  const advertsListArr = advertsList?.details?.results;

  const renderAdvertsList = () => {
    if (advertsList.status === status.SHOULD_CALL_API || advertsList.status === status.FETCHING)
      return (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      );

    if (advertsList.status === status.SUCCESS && advertsListArr?.length > 0)
      return (
        <>
          <AdvertsList
            advertsListArr={advertsListArr}
            isActionPopupOpen={isActionPopupOpen}
            isActionPopupLoading={isActionPopupLoading}
            actionPopupStatus={actionPopupStatus}
            handleTextToCopyToClipboardClick={handleTextToCopyToClipboardClick}
            handleActionBtnClick={handleActionBtnClick}
            handleActionPopupConfirmBtnClick={handleActionPopupConfirmBtnClick}
            handleActionPopupDismissBtnClick={handleActionPopupDismissBtnClick}
          />
          {numberOfPages > 1 && (
            <PaginationWrapper>
              <Pagination
                currentPage={selectedPageFilter}
                totalCount={numberOfPages}
                handleOrderPaginationClick={handleOrderPaginationClick}
              />
            </PaginationWrapper>
          )}
          {showCopiedTextOverlay && (
            <ToastTextOverlay>{advertsStrings.advertsList.copiedToClipboardText}</ToastTextOverlay>
          )}
        </>
      );

    return (
      <NoResultsWrapper>
        <NoResultsText>{advertsStrings.advertsList.advertsGridNoResultsFound}</NoResultsText>
      </NoResultsWrapper>
    );
  };

  return (
    <AdvertsWrapper>
      <AdvertsFilter
        searchQuery={searchQuery}
        handleSearchBarInputChange={handleSearchBarInputChange}
      />
      {renderAdvertsList()}
    </AdvertsWrapper>
  );
};

AdvertsComponent.propTypes = {
  showCopiedTextOverlay: PropTypes.bool.isRequired,
  searchQuery: PropTypes.string.isRequired,
  selectedPageFilter: PropTypes.number.isRequired,
  isActionPopupOpen: PropTypes.bool.isRequired,
  isActionPopupLoading: PropTypes.bool.isRequired,
  actionPopupStatus: PropTypes.number.isRequired,
  handleTextToCopyToClipboardClick: PropTypes.func.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
  handleOrderPaginationClick: PropTypes.func.isRequired,
  handleActionBtnClick: PropTypes.func.isRequired,
  handleActionPopupConfirmBtnClick: PropTypes.func.isRequired,
  handleActionPopupDismissBtnClick: PropTypes.func.isRequired,
};

export default AdvertsComponent;
